module.exports = __webpack_public_path__ + "static/media/logo.686137d0.jpg";